import { request } from "@/api";
import cookies from 'js-cookie'
import { getStringYmdtWithoutSeparator } from '@/utils/dateUtils';

const ENDPOINT_GOALSETTING = 'MealWorkout/GoalSetting'
const ENDPOINT_SAVEGUIDE = 'MealWorkout/SaveGuide'
const ENDPOINT_DETAIL = 'MealWorkout/Detail'
const ENDPOINT_WORKOUT_PLAN = 'MealWorkout/BasicStrengthWorkoutPlan'
const ENDPOINT_NUTRITION_PER_MEAL = 'MealWorkout/NutritionPerMeal'

export default {
  namespaced: true,
  state: {
    isExistInBodyGoal: false,
    isHighExercise: false,
    userNickName: '',
    inbodyData: null,
    selectedExeActivity: 0,
    selectedExerciseList: [],
    userInfo: {},
    inputGoalData: {
      periodNum: 8,
      SMMNum: 1.0,
      BFMNum: -2.0
    },
    dietGuideResult: null,
    workoutPlan: null,
    nutritionList: null
  },
  actions: {
    async getGoalData ({ state }, payload) {
      const params = {
        datetimes: getStringYmdtWithoutSeparator(payload.datetimes),
        weekNum: state.inputGoalData.periodNum,
        diffSmm: state.inputGoalData.SMMNum,
        diffBfm: state.inputGoalData.BFMNum,
        uId: cookies.get('UID'),
        appType: cookies.get('AppType'),
        appVersion: cookies.get('AppVersion'),
        languageCode: cookies.get('LanguageCode'),
        countryCode: cookies.get('CountryCode'),
        utcInterval: cookies.get('UTCInterval'),
        whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
      }
      const resp = await request(ENDPOINT_GOALSETTING, 'post', params)

      if (resp.data !== undefined && resp.data !== null) {
        state.inbodyData = resp.data.goalData
        state.userInfo = resp.data.parameter
        state.isExistInBodyGoal = resp.data.isUseAchieveGoal
      }
      state.userNickName = cookies.get('UserNickName')
      console.log(state.inbodyData)
      console.log(state.userInfo)
      console.log(state.isExistInBodyGoal)
    },
    async setDietGuide ({ state }, payload) {
      let exerciseList = []
      for (let i = 0; state.selectedExerciseList.length > i; i++) {
        let filteredExerciseList = {
          exerciseCode: state.selectedExerciseList[i].workOutCode, 
          exerciseFreq: state.selectedExerciseList[i].frequency, 
          exerciseDuration: state.selectedExerciseList[i].originTimes, 
          exerciseIntensity: state.selectedExerciseList[i].intensity
        }
        exerciseList.push(filteredExerciseList)
      }

      // 인바디결과 데이터는 사용자가 빅데이터 목표가 있는 경우 목표기준 인바디 데이터로 전송하고, 없는 경우 최근 인바디 데이터로 전송한다.
      let refInBodyDatetimes = state.inbodyData.achieveGoalKey === null || state.inbodyData.achieveGoalKey === undefined || state.inbodyData.achieveGoalKey === ''? state.userInfo.datetimes : state.inbodyData.datetimes

      const params = {
        isOverWorkOut: state.isHighExercise,
        achieveGoalKey: state.inbodyData.achieveGoalKey,
        startDate: payload.startDate,
        datetimes: refInBodyDatetimes,
        diffSmm: state.inbodyData.diffSmm,
        diffBfm: state.inbodyData.diffBfm,
        activityCode: state.selectedExeActivity,
        exerciseList: exerciseList,
        weekNum: state.inbodyData.weekNum,
        uId: state.userInfo.uId,
        appType: state.userInfo.appType,
        appVersion: state.userInfo.appVersion,
        languageCode: state.userInfo.languageCode,
        countryCode: state.userInfo.countryCode,
        utcInterval: state.userInfo.utcInterval,
        whereToUseCode: state.userInfo.whereToUseCode === undefined ? null : state.userInfo.whereToUseCode
      }
      console.log(params)
      const resp = await request(ENDPOINT_SAVEGUIDE, 'post', params)
      console.log('result ' + resp.data.result)
    },
    async getDietGuide ({ state }) {
      const params = {
        uId: cookies.get('UID'),
        appType: cookies.get('AppType'),
        appVersion: cookies.get('AppVersion'),
        languageCode: cookies.get('LanguageCode'),
        countryCode: cookies.get('CountryCode'),
        utcInterval: cookies.get('UTCInterval'),
        whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
      }
      const resp = await request(ENDPOINT_DETAIL, 'post', params)
      if (resp.data !== undefined && resp.data !== null) {
        state.dietGuideResult = resp.data
      }
      console.log(state.dietGuideResult)
    },
     async getWorkoutPlan ({ state }) {
      const params = {
        exerciseId: state.dietGuideResult.exerciseId,
        exerciseTime: state.dietGuideResult.exerciseTime,
        uId: cookies.get('UID'),
        appType: cookies.get('AppType'),
        appVersion: cookies.get('AppVersion'),
        languageCode: cookies.get('LanguageCode'),
        countryCode: cookies.get('CountryCode'),
        utcInterval: cookies.get('UTCInterval'),
        whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
      }
      const resp = await request(ENDPOINT_WORKOUT_PLAN, 'post', params)
      if (resp.data !== undefined && resp.data !== null) {
        state.workoutPlan = resp.data.strengthWorkoutGroupList
      }
     },
     async getNutritionList ({ state }, payload) {
      const params = {
        mealCount: payload.mealCount,
        uId: cookies.get('UID'),
        appType: cookies.get('AppType'),
        appVersion: cookies.get('AppVersion'),
        languageCode: cookies.get('LanguageCode'),
        countryCode: cookies.get('CountryCode'),
        utcInterval: cookies.get('UTCInterval'),
        whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
      }
      const resp = await request(ENDPOINT_NUTRITION_PER_MEAL, 'post', params)
      if (resp.data !== undefined && resp.data !== null) {
        state.nutritionList = resp.data
      }
      console.log(state.nutritionList)
     }
  },
  mutations: {
    SET_SELECTED_EXE_ACTIVITY (state, data) {
      state.selectedExeActivity = data
    },
    SET_SELECTED_EXERCISE (state, data) {
      state.selectedExerciseList.push(data)
    },
    CHECK_HIGH_EXERCISE (state) {
        // 과도한 운동량 계산
      let exeWeekTime = []
      let Tw = 0
      let computedIntencity = []
      let highExeScore = 0
      let exeIntencityCoefficient = []

      if (state.selectedExerciseList.length > 0) {
        for (let i = 0; state.selectedExerciseList.length > i; i++) {
          // 주간 운동 시간 계산
          let weekTime = (state.selectedExerciseList[i].frequency * state.selectedExerciseList[i].times) / 60
          exeWeekTime.push(weekTime)
          // 운동별 강도
          let intencity = state.selectedExerciseList[i].intensity
          let exeIntencity = 0
          if (intencity === 1) exeIntencity = 0.25
          else if (intencity === 2) exeIntencity = 0.5
          else if (intencity === 3) exeIntencity = 1
          else if (intencity === 4) exeIntencity = 1.25
          else if (intencity === 5) exeIntencity = 1.5
          computedIntencity.push(exeIntencity)
        }
        // 총 주간 운동시간(Tw) 계산
        exeWeekTime.forEach(e => Tw += e)
        // 운동별 강도 계수
        for (let i = 0; state.selectedExerciseList.length > i; i++) {
          let IntencityCoefficient = (computedIntencity[i] * exeWeekTime[i]) / Tw
          exeIntencityCoefficient.push(IntencityCoefficient)
        }
        // 과도한 운동량 계산
        for (let i = 0; state.selectedExerciseList.length > i; i++) {
          highExeScore += exeIntencityCoefficient[i] * state.selectedExerciseList[i].frequency
        }
        // 결과
        if (12 <= Tw || 10 <= highExeScore) state.isHighExercise = true
        else state.isHighExercise = false
      }
    },
    DELETE_SELECTED_EXERCISE (state, index) {
      state.selectedExerciseList.splice(index, 1)
    },
    INIT_GOAL_SETUP_DATA (state) {
      state.inputGoalData = {
        periodNum: 8,
        SMMNum: 1.0,
        BFMNum: 2.0
      }
      state.inbodyData = {}
    },
    INIT_SELECTED_EXE_ACTIVITY (state) {
      state.selectedExeActivity = 0
    },
    INIT_SELECTED_EXERCISE_LIST (state) {
      state.selectedExerciseList = []
    },
    INIT_ALL_SELECTED_DATA (state) {
      state.inputGoalData = {
        periodNum: 8,
        SMMNum: 1.0,
        BFMNum: 2.0
      }
      state.selectedExeActivity = 0
      state.selectedExerciseList = []
      state.isHighExercise = false
    }
  }
}